import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row justify-content-end" }
const _hoisted_2 = ["title"]
const _hoisted_3 = ["for"]
const _hoisted_4 = ["id", "onUpdate:modelValue"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "row justify-content-center" }
const _hoisted_7 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("i", {
        title: _ctx.$t('messages.Write translation text box'),
        "data-placement": "bottom",
        "data-toggle": "tooltip",
        style: {"font-size":"30px"},
        class: "far"
      }, "", 8, _hoisted_2)
    ]),
    _createElementVNode("form", {
      autocomplete: "off",
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.check && _ctx.check(...args)), ["prevent"]))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.translations, (translation) => {
        return (_openBlock(), _createElementBlock("div", {
          key: translation.fromId,
          class: "row justify-content-center"
        }, [
          _createElementVNode("label", {
            for: 'listto'+translation.fromId,
            class: "h4 form-control-label"
          }, _toDisplayString(translation.fromName), 9, _hoisted_3),
          _withDirectives(_createElementVNode("input", {
            id: 'listto'+translation.fromId,
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": ($event: any) => (translation.guess = $event)
          }, null, 8, _hoisted_4), [
            [_vModelText, translation.guess]
          ])
        ]))
      }), 128)),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", _hoisted_7, [
          _createTextVNode(_toDisplayString(_ctx.$t("messages.check answer")) + " ", 1),
          _hoisted_8
        ])
      ])
    ], 32)
  ], 64))
}